<div class="grid-container text-base">
    <table aria-describedby="View Plates" class="table">
        <thead>
            <tr class="head">
                <th class="column1" scope="col"></th>
                <th class="column1" scope="col" *ngFor="let col of formattedColumnHeaders; let k = index">
                    {{ col }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rowHeaders; let i = index;">
                <td class="column1">{{ row }}</td>
                <td *ngFor="let col of formattedColumnHeaders; let j = index">
                    <input class="w-12 h-3rem border-none text-center" pInputText type="text"
                    [style.background]="getSelectedCellBackgroundColor(i, j)" [ngClass]="determineCellColorValue(i,j)"
                    [class.cells-with-selection]="isCellSelected(i,j)" (click)="selectTableCell(i, j)"
                    [value]="getSampleAt(i, j).sampleID" [pTooltip]="getSampleAt(i, j).sampleID"
                    tooltipPosition="top" readonly />
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="flex justify-content-center mt-1">
    <p class="bg-primary bg-auto font-bold p-1">Please double click on a cell to add a sample comment</p>
</div>
<p-dialog header="{{ getSampleCommentsDialogHeader() }}" [(visible)]="showSampleComment" [maximizable]="true" [modal]="true" [style]="{ 'width': '50vw', 'height': '65vh' }" [breakpoints]="{'960px':'75vw','648px':'85vw'}">
    <app-comment *ngIf="this.sampleBarcodeMap.has(this.selectedCell)" [selectedLabID]="selectedLabID" [puid]="puid" [displayDialog]="showSampleComment" [showSampleComment]="true" 
    [sampleID]="this.plateSamplesMap.get(this.selectedCell)._id" [sampleBarcode]="this.plateSamplesMap.get(this.selectedCell).barCode" (onCommentClosed)="showSampleComment = false">
    </app-comment>
</p-dialog>